module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "epi",
    attrs: {
      "id": "epi"
    }
  }, [_c('a', {
    attrs: {
      "id": "pVI"
    }
  }), _c('a', {
    attrs: {
      "id": "pVII"
    }
  }), _c('i', [_vm._v("“It is difficult to get a man to understand something, "), _c('br'), _vm._v("when his salary depends upon his not understanding it!”")])]), _vm._v(" "), _c('p', {
    staticClass: "epis"
  }, [_c('i', [_vm._v("Upton Sinclair")]), _vm._v(", I, Candidate for Governor: And How I Got Licked")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18a0d7e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/epigraph.vue
// module id = 69
// module chunks = 0